<template>
    <van-tabs v-model="subActive" type="card" color="#1989fa" sticky :offset-top="100">
        <van-tab title="还款卡核验" v-if="repayCheckAccess">
            <UpperMajor :applyId="applyId" :isEdit="isEdit&&repayCheckAccess"></UpperMajor>
        </van-tab>
        <van-tab title="回款卡核验" v-if="backCheckAccess">
            <DownMajor :applyId="applyId" :isEdit="isEdit&&backCheckAccess"></DownMajor>
        </van-tab>
    </van-tabs>
</template>

<script>
  import UpperMajor from './upper_major'
  import DownMajor from './down_major'
  export default {
    name: 'Major',
    components: {
      UpperMajor,
      DownMajor
    },
    props: {
      applyId: {
        type: String,
        default: ''
      },
      isEdit:{
        type:Boolean,
        default:false
      },
      backCheckAccess:{
        type:Boolean,
        default:false
      },
      repayCheckAccess:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
          subActive: '0',

      }
    },
  }
</script>